/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

// Summary And Greeting Section

import emoji from "react-easy-emoji";
import mysqlIcon from '@iconify-icons/cib/mysql';
import pytorchlightningIcon from '@iconify-icons/simple-icons/pytorchlightning';
import tensorflowIcon from '@iconify-icons/simple-icons/tensorflow';
import pytorch from '@iconify-icons/simple-icons/pytorch'
import pythonIcon from '@iconify-icons/fa-brands/python';
import scikitlearnIcon from '@iconify-icons/simple-icons/scikitlearn';
import hadoopIcon from '@iconify-icons/grommet-icons/hadoop';
import amazondynamodbIcon from '@iconify-icons/simple-icons/amazondynamodb';
import djangoIcon from '@iconify-icons/cib/django';
import dockerIcon from '@iconify-icons/file-icons/docker';
import swiftIcon from '@iconify-icons/fa-brands/swift';
import faceId from '@iconify-icons/iconoir/face-id';
import googleCloud from '@iconify-icons/cib/google-cloud';
import awsIcon from '@iconify-icons/fontisto/aws';
import bxlCPlusPlus from '@iconify-icons/bx/bxl-c-plus-plus';

import { createGlobalStyle } from 'styled-components';

export const Globalstyle = createGlobalStyle`　
@font-face {
  font-family: "Yellowtail-Regular";
  font-style: normal;
  font-weight: bold;
  src: local("Yellowtail-Regular"),
    url("./assets/fonts/Yellowtail-Regular.woff") format("woff");
}`


const illustration = {
  animated: false // set to false to use static SVG
};

const greeting = {
  username: "Aymane Hachcham",
  title: "Hi all, I'm Aymane Hachcham",
  subTitle: "Applied data science and machine learning practitioner, I have grown knowledge of data and its impact on the company's activity, delivering forecasting models and data-driven insights to increase the company's productivity.",
  resumeLink:
    "https://drive.google.com/file/d/1QRP2WVyWJguxsS8QAKoxF3xI2lyTu8S9/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links
const socialMediaLinks = {
  github: "https://github.com/aymanehachcham",
  linkedin: "https://www.linkedin.com/in/aymane-hachcham/",
  medium: "https://aymanehachchaming.medium.com/",
  twitter: "https://twitter.com/aymane_hach",
  display: true // Set true to display this section, defaults to false
};

// Skills Section
const skillsSection = {
  title: "Data Scientist & AI Engineer",
  subTitle: "",
  skills: [
    emoji(
      "⚡ Leverage knowledge of data science, methodologies, and processing techniques to analyze vast amounts of data for decision support"
    ),
    emoji("⚡ Deploy state-of-the-art speech recognition and voice cloning into cloud serving platforms"),
    emoji(
      "⚡ Drive the development of end-to-end ASR & TTS systems including model pruning, quantization and compression for On-Device deployment purposes"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Python",
      icon: pythonIcon
    },
    {
      skillName: "C++",
      icon: bxlCPlusPlus
    },
    {
      skillName: "Pytorch",
      icon: pytorch
    },
    {
      skillName: "Pytorch-Lightning",
      icon: pytorchlightningIcon
    },
    {
      skillName: "Tensorflow",
      icon: tensorflowIcon
    },
    {
      skillName: "SQL",
      icon: mysqlIcon
    },
    {
      skillName: "Sci-Kit Learn",
      icon: scikitlearnIcon
    },
    {
      skillName: "Hadoop",
      icon: hadoopIcon
    },
    {
      skillName: "DynamoDB",
      icon: amazondynamodbIcon
    },
    {
      skillName: "AWS",
      icon: awsIcon
    },
    {
      skillName: "Google Cloud Plateform",
      icon: googleCloud
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Technical University of Dortmund",
      logo: require("./assets/images/TUD.jpg"),
      subHeader: "MS in Data Science",
      duration: "September 2021 - July 2023",
      descBullets: [
      ]
    },
    {
      schoolName: "Laureate International Universities | UIC Casablanca",
      logo: require("./assets/images/Laureate.jpeg"),
      subHeader: "B.S. in Computer Science & Data Analyses",
      duration: "September 2015 - July 2020",
      desc: "Ranked top 10% in the program. Took courses about Software Engineering, Data Analyses & Cyber Security",
      descBullets: []
    }
  ]
};

// Your top 3 proficient stacks/tech experience

/*const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};*/

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Data Scientist & AI Engineer - Fulltime",
      company: "Spotbills Morocco",
      companylogo: require("./assets/images/Spotbills.jpeg"),
      companyBgColor: "#FFC107",
      date: "Sep 2020 – Present",
      desc: "Machine learning practitioner, AI developer in Computational Linguistics, Speech processing and ASR & TTS systems",
      descBullets: [

      ]
    },
    {
      role: "Data Scientist - Fulltime",
      company: "Dun & Bradstreet | QUANTIK",
      companylogo: require("./assets/images/db-logo.jpg"),
      companyBgColor: '#0097A7',
      date: "Feb 2020 – August 2020",
      desc: "Developed a predictive scoring indicator for monitoring financial risk management on investment loans granted to Moroccan companies."
    },
    {
      role: "ML Designer - Internship",
      company: "EVEAD Group",
      companylogo: require("./assets/images/evead.jpg"),
      companyBgColor: '#00B0FF',
      date: "May 2019 – Sep 2019",
      desc: "Designed ML models for image classification and recognition leveraging Pytorch Convolutional modules, text analysis with NLP cutting-edge technologies to shape an analytics web-based platform."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: "Github Projects",
  subtitle:
    "A list of my most recent open source projects",

  achievementsCards: [
    {
      title: "A Backend Service for Conversational AI",
      subtitle:
        "A Django based REST API for serving ASR & TTS systems relating to Conversational Nvidia Neural Modules",
      image: require("./assets/images/nvidia-logo-big.jpg"),
      footerLink: [
        {
          name: "Github Link",
          url: "https://github.com/aymanehachcham/Conversational-API",
          icon1: pythonIcon,
          icon2: pytorch,
          icon3: tensorflowIcon,
        },
      ]
    },
    {
      title: "Deep Lab V3 Semantic Segmentation API",
      subtitle:
        "Developed a Django API that performs background customization using Semantic Segmentation",
      image: require("./assets/images/2project.jpeg"),
      footerLink: [
        {
          name: "Github Link",
          url: "https://github.com/aymanehachcham/DeepLabV3-SemanticSeg-API",
          icon1: pythonIcon,
          icon2: pytorch,
          icon3: djangoIcon,
        },
      ]
    },

    {
      title: "Microservice Architecture to serve a speech synthesizer",
      subtitle: "API to serve an end-to-end speech synthesizer and deploy a production-ready version leveraging docker, Gunicorn and Nginx.",
      image: require("./assets/images/3project.jpeg"),
      footerLink: [
        {
          name: "Github Link",
          url: "https://github.com/aymanehachcham/Tacotron2-api-deployment",
          icon1: pytorch,
          icon2: djangoIcon,
          icon3: dockerIcon,
        }
      ]
    },

    {
      title: "Face Recognition App Using Swift, Core ML, and TuriCreate",
      subtitle: "IOS Application that performs real-time face recognition on camera using on-device Machine Learning",
      image: require("./assets/images/4project.jpg"),
      footerLink: [
        {
          name: "Github Link",
          url: "https://github.com/aymanehachcham/FaceRecogntion-CoreML",
          icon1: swiftIcon,
          icon2: faceId,
          icon3: pytorch,
        }
      ]
    },

  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Latest Articles",
  subtitle:
    "A hand-picked collection of my best online articles",

  blogs: [
    {
      url: "https://neptune.ai/blog/xgboost-everything-you-need-to-know",
      title: "XGBoost: Everything You Need to Know",
      description:
        "Gradient boosting (GBM) trees learn from data without a specified model, they do unsupervised learning. XGBoost is a popular gradient-boosting library for GPU training, distributed computing, and ..."
    },
    {
      url: "https://neptune.ai/blog/etl-in-machine-learning",
      title: "In-Depth ETL in Machine Learning Tutorial – Case Study With Neptune",
      description:
        "Most of the time, as data scientists, we think that our core value is our ability to figure out a machine learning algorithm that solves a task. In reality, model training is just the final part of a large body of work, mainly with data, that’s required just to start building a model."
    },
    {
      url: "https://neptune.ai/blog/conversational-ai-nvidia-tools-guide",
      title: "Conversational AI Architectures Powered by Nvidia: Tools Guide",
      description:
        "With the latest improvements in deep learning fields such as natural speech synthesis and speech recognition, AI and deep learning models are increasingly entering our daily lives."
    },
    {
      url: "https://neptune.ai/blog/how-to-organize-your-ml-development",
      title: "How to Organize Your ML Development in an Efficient Way",
      image: require('./assets/images/nextuLogo.webp'),
      description:
        "One major issue that every data scientist and ML practitioner will eventually encounter is workflow management. Testing different scenarios and use cases, logging information and details, sharing and comparing results from a particular set of samples, visualizing the data, keeping track of insights."
    },
    {
      url: "https://towardsdatascience.com/exploring-image-processing-techniques-opencv-4860006a243",
      title: "Exploring Image Processing Techniques — OpenCV",
      description:
        "Image Processing is a field of knowledge that falls in Computer Vision. The premises of machine learning were first laid down by computer vision theory, applying a whole set of techniques to process and analyze imagery data to extract valuable information that computers and machines may use for a wide range of applications"
    },
    {
      url: "https://heartbeat.fritz.ai/an-architecture-for-production-ready-natural-speech-synthesizer-8d0870b76cba",
      title: "An architecture for production-ready natural speech synthesizer",
      description:
        "The recent improvements in the field of speech synthesis have lead to many innovative technologies, offering a wide range of useful applications like automatic speech recognition, natural speech synthesis, voice cloning, digital dictation, and so forth."
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Do not hesitate to contact me. My Inbox is open!",
  number: "+212 707171925",
  email_address: "hachcham.ayman@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  //techStack,
  workExperiences,
  bigProjects,
  openSource,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
